<template>
  <div>
    <ContentSectionLoader v-if="!loaded" />
    <Transition name="fade">
      <section v-if="loaded">
        <h4
          class="mt-0"
          v-text="'Latest Activity'"
        />
        <div
          v-if="activityFeedItems.data.length"
          class="flex flex-wrap items-stretch -ml-2 mr-2"
        >
          <div
            :is="activityComponent(item)"
            v-for="item in activityFeedItems.data"
            :key="item.uuid"
            :item="item"
          />
        </div>
        <div
          v-else
          class="empty mr-4 mt-4"
        >
          <section>
            <h2 v-text="'Nothing new to report'" />
            <p v-text="'Check back later for updates.'" />
          </section>
        </div>
      </section>
    </Transition>
  </div>
</template>

<script type="text/babel">
import NoResults from './activity-feed-item-types/NoResults'
import AccessRequestHasBeenCreated from './activity-feed-item-types/AccessRequestHasBeenCreated'
import DiscussionPostWasCreatedEvent from './activity-feed-item-types/DiscussionPostWasCreatedEvent'
import DiscussionPostApprovalResponseEvent from './activity-feed-item-types/DiscussionPostApprovalResponseEvent'
import BlogEntryWasPublishedEvent from './activity-feed-item-types/BlogEntryWasPublishedEvent'
import CalendarEventCreated from './activity-feed-item-types/CalendarEventCreated'
import PushNotificationCreated from './activity-feed-item-types/PushNotificationCreated'
import DocumentWasSharedToGroupOrMembershipsEvent
  from './activity-feed-item-types/DocumentWasSharedToGroupOrMembershipsEvent'
import FolderWasSharedToGroupOrMembershipsEvent
  from './activity-feed-item-types/FolderWasSharedToGroupOrMembershipsEvent'

export default {
  name: 'ActivityFeed',
  components: {
    NoResults,
    BlogEntryWasPublishedEvent,
    AccessRequestHasBeenCreated,
    DiscussionPostWasCreatedEvent,
    DiscussionPostApprovalResponseEvent,
    FolderWasSharedToGroupOrMembershipsEvent,
    DocumentWasSharedToGroupOrMembershipsEvent,
    CalendarEventCreated,
    PushNotificationCreated,
  },
  data() {
    return {
      loaded: false,
      activityFeedItems: {
        data: [],
      },
    }
  },
  async mounted() {
    await this.$nextTick()

    this.$api.active().get('activity-feed/items')
      .then((response) => {
        this.loaded = true
        this.activityFeedItems = response.data
      })
  },
  methods: {
    activityComponent(item) {
      return item.attributes.event
    },
  },
}
</script>